var render, staticRenderFns
import script from "./CListItemAvatar.vue?vue&type=script&lang=ts"
export * from "./CListItemAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports